module.exports = __webpack_public_path__ + "static/mailgun-get-api-key-1fdddca153cec4653083880db0338c65.png";